import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import RotaPrivada from './componentes/RotaPrivada';
import Avaliacao from './paginas/Avaliacao';
import Login from './paginas/Login';
import Sessao from './paginas/Sessao';
import Formulario from './paginas/Formulario';

const Rotas = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Default route redirect Libcom */}
        <Route exact path="/">
            <Redirect to="/login"/>
        </Route>
        <Route path="/login" exact component={Login} />
        <RotaPrivada path="/formularios" exact component={Formulario} />
        <RotaPrivada path="/formularios/:id_formulario/sessoes" exact component={Sessao} />
        <RotaPrivada path="/formularios/:id_formulario/sessoes/:id_sessao/:avaliacoes" exact component={Avaliacao} />
      </Switch>
    </BrowserRouter>
  )
}

export default Rotas;
